import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Profile from "./views/Profile.vue";
import Callback from "@/components/Callback";
import AuthEmailSuccess from "./views/AuthEmailSuccess.vue";
import AuthEmailFail from "./views/AuthEmailFail.vue";
import Register from "./views/Register.vue";
import RegisterSuccess from "./views/RegisterSuccess.vue";
import RegisterSwing from "./components/RegisterSwing.vue";
import Login from "./views/Login.vue";
import EmailAdd from "./views/EmailAdd.vue";
import ChangePassword from "./views/ChangePassword.vue";
import ForgotPassword from "./views/ForgotPassword.vue";
import ResetPassword from "./views/ResetPassword.vue";
import RecoverPhone from "./views/RecoverPhone.vue";
import RecoverPhoneVerify from "./views/RecoverPhoneVerify.vue";
import RecoverPhoneSuccess from "./views/RecoverPhoneSuccess.vue";
import Events from "./components/Events.vue";
import Event from "./components/Event.vue";
import EventJoinGroup from "./components/EventJoinGroup.vue";
import EventMyGroup from "./components/EventMyGroup.vue";
import EventMyTicket from "./components/EventMyTicket.vue";
//import EventMyTickets from "./components/EventMyTickets.vue";
import EventGetTransfer from "./components/EventGetTransfer.vue";
import EventBuyTicket from "./components/EventBuyTicket.vue";
import EventWristband from "./components/EventWristband.vue";
import EventOrders from "./components/EventOrders.vue";
import EventOrder from "./components/EventOrder.vue";
import EventProductsCategory from "./components/EventProductsCategory.vue";
import EventProduct from "./components/EventProduct.vue";
import EventProductSaleKrbank from "./components/EventProductSaleKrbank.vue";
import EventProductSaleCod from "./components/EventProductSaleCod.vue";
import EventProductSalePaypal from "./components/EventProductSalePaypal.vue";
import EventProductSaleAlipay from "./components/EventProductSaleAlipay.vue";
import EventProductSaleWirexfer from "./components/EventProductSaleWirexfer.vue";
import EventProductSaleInstacode from "./components/EventProductSaleInstacode.vue";
import EventMyTeamSwapManager from "./components/EventMyTeamSwapManager.vue";
import EventMyTeamInviteManager from "./components/EventMyTeamInviteManager.vue";

Vue.use(Router);

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/events",
      name: "events",
      component: Events,
    },
    {
      path: "/events/register/swing/:event_id",
      name: "register_swing",
      component: RegisterSwing,
    },
    {
      path: "/events/:event_id",
      name: "event",
      component: Event,
    },
    /*
    {
      path: "/events/:event_id/my_tickets",
      name: "event_my_ticket",
      component: EventMyTickets,
    },
    */
    {
      path: "/events/:event_id/my_ticket",
      name: "event_my_ticket",
      component: EventMyTicket,
    },
    {
      path: "/events/:event_id/get_transfer",
      name: "event_get_transfer",
      component: EventGetTransfer,
    },
    {
      path: "/events/:event_id/join_team",
      name: "event_join_team",
      component: EventJoinGroup,
    },
    {
      path: "/events/:event_id/my_team",
      name: "event_my_team",
      component: EventMyGroup,
    },
    {
      path: "/events/:event_id/my_team/:team_id/swap_manager",
      name: "event_my_team_swap_manager",
      component: EventMyTeamSwapManager,
    },
    {
      path: "/events/:event_id/my_team/:team_id/invite_manager",
      name: "event_my_team_invite_manager",
      component: EventMyTeamInviteManager,
    },
    {
      path: "/events/:event_id/product_category/:category",
      name: "event_products_category",
      component: EventProductsCategory,
    },
    {
      path: "/events/:event_id/products/:product_id",
      name: "event_product",
      component: EventProduct,
    },
    {
      path:
        "/events/:event_id/products/:product_id/sale_krbank/:sales_channel_id",
      name: "event_product_sale_krbank",
      component: EventProductSaleKrbank,
    },
    {
      path:
        "/events/:event_id/products/:product_id/sale_paypal/:sales_channel_id",
      name: "event_product_sale_paypal",
      component: EventProductSalePaypal,
    },
    {
      path: "/events/:event_id/products/:product_id/sale_cod/:sales_channel_id",
      name: "event_product_sale_cod",
      component: EventProductSaleCod,
    },
    {
      path:
        "/events/:event_id/products/:product_id/sale_alipay/:sales_channel_id",
      name: "event_product_sale_alipay",
      component: EventProductSaleAlipay,
    },
    {
      path: "/events/:event_id/products/:product_id/sale_wirexfer",
      name: "event_product_sale_wirexfer",
      component: EventProductSaleWirexfer,
    },
    {
      path:
        "/events/:event_id/products/:product_id/sale_instacode/:sales_channel_id",
      name: "event_product_sale_instacode",
      component: EventProductSaleInstacode,
    },
    {
      path: "/events/:event_id/buy_ticket",
      name: "event_buy_ticket",
      component: EventBuyTicket,
    },
    {
      path: "/events/:event_id/wristband",
      name: "event_wristband",
      component: EventWristband,
    },
    {
      path: "/events/:event_id/orders",
      name: "event_orders",
      component: EventOrders,
    },
    {
      path: "/events/:event_id/orders/:order_id",
      name: "event_order",
      component: EventOrder,
    },
    {
      path: "/profile/email_add",
      name: "email_add",
      component: EmailAdd,
    },
    {
      path: "/profile/register/waitcode/:save_cc/:save_phone",
      name: "register_waitcode",
      component: Register,
    },
    {
      path: "/profile/register",
      name: "register",
      component: Register,
    },
    {
      path: "/profile/register_success",
      name: "register_success",
      component: RegisterSuccess,
    },
    {
      path: "/profile/login",
      name: "login",
      component: Login,
    },
    {
      path: "/profile/password",
      name: "password",
      component: ChangePassword,
    },
    {
      path: "/forgot_password",
      name: "forgot_password",
      component: ForgotPassword,
    },
    {
      path: "/recover_phone/waitcode/:save_cc/:save_phone",
      name: "recover_phone_waitcode",
      component: RecoverPhoneVerify,
    },
    {
      path: "/recover_phone/success",
      name: "recover_phone_success",
      component: RecoverPhoneSuccess,
    },
    {
      path: "/recover_phone",
      name: "recover_phone",
      component: RecoverPhone,
    },
    {
      path: "/reset_password/:code",
      name: "reset_password",
      component: ResetPassword,
    },
    {
      path: "/authemail/success",
      component: AuthEmailSuccess,
    },
    {
      path: "/authemail/fail",
      component: AuthEmailFail,
    },
    {
      path: "/callback",
      name: "Callback",
      component: Callback,
    },
    {
      path: "/profile",
      name: "profile",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "profile" */ "./views/Profile.vue"),
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue"),
    },
  ],
});
